//https://ant.design/docs/react/customize-theme#seedtoken
//Custom variables not used by ant algo will be passed to css. 
//Names are converted to snake case.

export const theme = {
    token: {
        colorPrimary: "#0169CD",
        colorBorder: "#666",
        colorBorderSecondary: "#666",
        colorError: "#ff3436",

        borderRadius: 6,

        fontFamily: "Mona Sans",
        fontFamilyCode: "Mona Sans", 


        fontSizeHeading1: 26,
        fontSizeHeading2: 22,
        fontSizeHeading3: 18,
        fontSizeHeading4: 16,
        fontSizeHeading5: 14,

        lineHeightHeading1:1,

        stepSize: 4,


        // fontSize: 14,
        // fontSizeSM: 12,
        // fontSizeLG: 16,
        // fontSizeXL: 20,
        // fontSizeXXL: 24,
    
        // fontSizeHeading1: 38,
        // fontSizeHeading2: 30,
        // fontSizeHeading3: 24,
        // fontSizeHeading4: 20,
        // fontSizeHeading5: 16,
    
        // fontSizeIcon: 12,
    
        // lineHeight: 22,
        // lineHeightSM: 20,
        // lineHeightLG: 24,
    
        // lineHeightLabel: 18,
        // lineHeightHeading1: 46,
        // lineHeightHeading2: 38,
        // lineHeightHeading3: 32,
        // lineHeightHeading4: 28,
        // lineHeightHeading5: 24,
    
        fontWeightNormal: 400,
        fontWeightStrong: 600,

    
        // sizeXSS: 4,
        // sizeXS: 8,
        // sizeSM: 12,
        // sizeMD: 16,
        // size: 16,
        // sizeLG: 24,
        // sizeXL: 32,
        // sizeXXL: 48,
    

        //extra
        instExtra: "#eba123",

        //layoutSiderBackgroundColor: "#0000ff",
        layoutSiderBackgroundColor: "#001529",
        layoutNavbarHeight: 60,
        layoutSiderWidth: 75,
        layoutSiderExpandedWidth: 260,
        layoutMaxWidth: 1284,
        
        superListExpandableFirstLevelBackgroundColor: "#f9f9f9",
        superListExpandableSecondLevelBackgroundColor: "#eaeaea",
        
    }
}